import * as React from 'react';
import axios from 'axios';

import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';

import PreloaderAnim from './PreloaderAnim'

import {destURL,createUserData} from './../utils/Utils'

import Medal1 from './../gfx/medal1-ok.svg'
import Medal2 from './../gfx/medal2-ok.svg'
import Medal3 from './../gfx/medal3-ok.svg'

import RegelsMedalsBirdie from './RegelsMedalsBirdie'

const dommeKreten = [
  "Bah, wat een smerig goeie golfers zijn we toch! 🐦",
  "Jezus, wie is hier zo obsceen lekker bezig?! 🔥",
  "Gadver, dit is gewoon walgelijk goed gespeeld! 💪",
  "Potverdansen, we slaan die bal er gewoon in! 🎯",
  "Schaamteloos goed bezig, stelletje ballenkunstenaars! ⛳",
  "Nou nou, we kunnen er ook wat van hè, vieze vogeljagers! 🦅",
  "Dit is gewoon niet normaal meer, smeerlappen! 👏",
  "Holy moly, wat een bende talenten bij elkaar! 🏆",
  "Jakkes, zo goed dat het pijn doet! 😎",
  "Getverdemansen, de birdies vliegen ons om de oren! 🐤"
];

export default function BirdiesComponent() {
  const [regels, setRegels] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(null);
  const [kreet] = React.useState(() => dommeKreten[Math.floor(Math.random() * dommeKreten.length)]);

  React.useEffect(() => {
//    let u = destURL + "?test=1"
    let u = destURL + "?"+window._currentYear+"=1"
    if(window.location.href.indexOf("dinsdaghakkers") > -1 )u = destURL + "?"+window._currentYear+"=1"
    axios.get(u)
      .then(res => {
        let uData = createUserData(res.data)
        console.log(uData)
        let arr = []
        let a = Object.keys(uData)
        for(let i=0;i<a.length;i++) {
          let u = uData[a[i]]
          let score = u.getMeanScore(5)
          let birds = u.getBirdies()
          let name = u.getName()
          arr.push({name:name,score:score,birds:birds})
        }
        // Sort by birdies (highest first), if equal or zero sort by last name
        arr.sort((a,b) => {
          const birdsA = a.birds || 0
          const birdsB = b.birds || 0
          if (birdsA === birdsB || (birdsA === 0 && birdsB === 0)) {
            // Sort by last name (alphabetically)
            const lastNameA = a.name.split(' ').pop().toLowerCase()
            const lastNameB = b.name.split(' ').pop().toLowerCase()
            return lastNameA.localeCompare(lastNameB)
          }
          return birdsB - birdsA
        })
        setRegels(arr)
        setLoading(false)
      })
      .catch(err => {
        console.error('Fout bij ophalen data:', err)
        setError('Kon de data niet ophalen. Controleer je internetverbinding of probeer het later opnieuw.')
        setLoading(false)
      })
  },[]);

  return (
    <>
        <Toolbar />
        <h1 style={{margin:0}}>Birdie klassement</h1>
        {loading && <PreloaderAnim />}
        {error && (
          <div style={{padding: '20px', backgroundColor: '#ffebee', borderRadius: '8px', color: '#c62828', marginTop: '20px'}}>
            <strong>Fout:</strong> {error}
          </div>
        )}
        {!loading && !error && regels.map((item, i) => {
          return <RegelsMedalsBirdie key={i} index={i} medal={i+1} caption={item.name} count={item.birds} />
         })}
         {!loading && !error && (
           <p style={{
             marginTop: '30px',
             padding: '15px',
             backgroundColor: 'rgba(255,255,255,0.7)',
             borderRadius: '12px',
             textAlign: 'center',
             fontStyle: 'italic',
             fontSize: '16px',
             color: '#2e7d32',
             animation: 'rowSlideIn 0.4s ease-out forwards',
             animationDelay: `${regels.length * 0.08 + 0.3}s`,
             opacity: 0
           }}>
             {kreet}
           </p>
         )}
         <Toolbar />
    </>
  );
}